import { PropsWithChildren, useEffect, useState } from "react";
import Header from "./Header";
import SideBar from "./SideBar";
import Theme from "../models/Theme";
import ThemeController from "../controllers/ThemeController";
import { useAuth } from "../_providers/AuthProvider";
import { ThemeProvider } from "../_providers/ThemeProvider";

const Layout = ({children}: PropsWithChildren<{}>) => {
    return (
        <div style={{ width: "100vw", height: "100vh"}}>
            <Header/>
            <div style={{height: "calc(100% - 60px)", width: "100%", display: "flex", flexDirection: "row"}}>
                <SideBar/>
                <ThemeProvider>
                    {children}
                </ThemeProvider>
            </div>
        </div>
    );
}

export default Layout;